<p-contextMenu #cm [model]="items" appendTo="body"></p-contextMenu>

<div class="grid">
  <div [ngClass]="change_logs.length > 0 ? 'col-8' : 'col-12'">
    <share-section-card title="Services" icon="pi pi-list">
      <div cardActions>
        <button
          pButton
          icon="pi pi-plus"
          label="Create"
          class="p-button-outlined p-button-sm"
          (click)="openCreateServiceDialog()"
        ></button>
      </div>
      <share-table
        [data]="services$"
        [columns]="columns"
        [(metaData)]="metadata"
        [menuItems]="menuItems"
        (metaDataChange)="getNetworkServices()"
        (selectedRowObservable$)="onRowSelect($event)"
        (selectedRowCMObservable$)="showContextAction($event)"
      ></share-table>
    </share-section-card>
  </div>

  <div *ngIf="change_logs.length > 0" class="col-4">
    <share-section-card title="Change History" icon="pi pi-history" shadow="shadow-1">
      <button
        cardActions
        pButton
        icon="pi pi-times"
        class="p-button-text p-button-danger p-button-sm"
        (click)="change_logs = []"
      ></button>
      <p-timeline [value]="change_logs" align="alternate">
        <ng-template pTemplate="marker" let-log>
          <i class="pi pi-hashtag"></i>
        </ng-template>
        <ng-template pTemplate="content" let-log>
          <div class="flex-auto p-3 surface-100 border-round mb-2">
            <div class="text-blue-600 font-semibold">{{ log.change_type | uppercase }}</div>
            <div class="text-700 text-sm">{{ log.reason_comments }}</div>
            <div class="text-500 text-xs mt-1">
              Request: {{ log.date_change_request | date: 'yyyy-MM-dd HH:mm' }}
            </div>
            <div class="text-500 text-xs">
              Effective: {{ log.date_effective | date: 'yyyy-MM-dd HH:mm' }}
            </div>
          </div>
        </ng-template>
      </p-timeline>
    </share-section-card>
  </div>
</div>
